import { render } from "./ValidationFieldSet.vue?vue&type=template&id=fbf0fed8&scoped=true&ts=true"
import script from "./ValidationFieldSet.vue?vue&type=script&lang=ts"
export * from "./ValidationFieldSet.vue?vue&type=script&lang=ts"

import "./ValidationFieldSet.vue?vue&type=style&index=0&id=fbf0fed8&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf0fed8"]])

export default __exports__